<template>
  <div v-if="user">
    <div class="col-12 text-left px-0">
      <router-link
        :to="{ name: 'Home' }"
        class="text-left text-secondary font-weight-bold ml-2 mr-auto d-flex align-content-center"
      >
        <ArrowLeftLogo />
        <span>Torna alla home</span>
      </router-link>
    </div>
    <div class="col-12 d-flex justify-content-end" v-if="!user.dottorfarma">
      <b-button variant="primary rounded-pill font-weight-bold" @click="showModal">Modifica password</b-button>
    </div>
    <h1 class="pt-4 text-capitalize">{{ user.anagrafica.fullname }}</h1>
    <b-overlay :show="loading" rounded="sm">
      <div class="py-2">
        <!-- <b-container fluid class="col-8 border-secondary mx-auto border__div px-0 pt-0 pb-4 mb-2"> -->
        <anagrafica-admin :utente="user" v-if="user.role == 'admin'" />
        <anagrafica-medico :utente="user" v-if="user.role == 'medico'" />
        <anagrafica-paziente :utente="user" v-if="user.role == 'paziente'" />
        <anagrafica-farmacista :utente="user" v-if="user.role == 'farmacista'" />
        <!-- </b-container> -->
      </div>
      <p v-if="msg">{{ msg }}</p>
    </b-overlay>
    <b-modal
      ref="pswchange"
      size="l"
      title="Modifica Password"
      scrollable
      centered
      header-bg-variant="primary"
      header-text-variant="white font-weight-bold"
      cancel-disabled
      ok-disabled
      ok-only
    >
      <b-form @submit.prevent="onSubmit">
        <p class="mb-0 mt-2">Inserisci la password attuale:</p>
        <b-form-input
          type="password"
          name="old"
          id="password"
          v-model="form.old"
          required
          placeholder="Vecchia password"
          class="mb-4 p-3 border-secondary"
        ></b-form-input>

        <p class="mb-0 mt-2">Inserisci la nuova password:</p>
        <b-form-input
          v-model="form.password"
          type="password"
          id="password"
          required
          :state="form.password ? minRequired:null"
          placeholder="La tua nuova password"
          class="mb-4 border-secondary"
        ></b-form-input>
        <p class="mb-0 mt-2">Conferma nuova password:</p>
        <b-form-input
          v-model="form.password_confirmation"
          type="password"
          id="password_confirmation"
          required
          placeholder="Conferma password"
          class="mb-4 p-3 border-secondary"
          :state="
                  form.password && form.password_confirmation == form.password
                    ? minRequired
                    : null
                "
          :class="
                  form.password !== form.password_confirmation &&
                    'border-danger'
                "
        ></b-form-input>
        <div class="row mx-auto text center pt-1">
          <p
            class="small__txt text-left"
          >*La password deve contenere un minimo di 8 caratteri ed includere almeno 1 numero, 1 maiuscola ed 1 minuscola.</p>
        </div>

        <div class="row mx-auto">
          <p class="text-danger" v-if="mistake">La password attuale non è corretta.</p>
        </div>

        <div class="row mx-auto text center pt-1">
          <b-button
            type="submit"
            variant="secondary"
            class="font-weight-bold mx-auto"
            :disabled="disableBtn"
          >Salva</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import AnagraficaAdmin from "@/components/anagrafica/AnagraficaAdmin";
import AnagraficaMedico from "@/components/anagrafica/medico/AnagraficaMedico";
import AnagraficaPaziente from "@/components/anagrafica/paziente/AnagraficaPaziente";
import AnagraficaFarmacista from "@/components/anagrafica/farmacista/AnagraficaFarmacista";
import ArrowLeftLogo from "@/../public/svg/arrow_left.svg";
export default {
  name: "Profilo",
  components: {
    AnagraficaAdmin,
    AnagraficaMedico,
    AnagraficaPaziente,
    AnagraficaFarmacista,
    ArrowLeftLogo
  },
  data() {
    return {
      user: null,
      disable: true,
      msg: null,
      error: false,
      categorie: [],
      loading: true,
      form: {
        password: "",
        password_confirmation: "",
        old: null
      },
      mistake: false
    };
  },
  watch: {},
  computed: {
    isMobile: function() {
      return this.$root.device < 575;
    },
    minRequired: function() {
      var space = this.form.password.indexOf(" ");
      if (space < 0) {
        var strongRegex = new RegExp(
          "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
        );
        return strongRegex.test(this.form.password);
      }
      return false;
    },
    disableBtn: function() {
      if (this.minRequired) {
        if (this.form.password === this.form.password_confirmation) {
          return false;
        }
        return true;
      }
      return true;
    }
  },
  methods: {
    fetchData() {
      var url = process.env.VUE_APP_VERSION + "users/user";
      this.$axios
        .get(url)
        .then(res => {
          this.user = res.data.data;
          // console.log(this.user);
          this.loading = false;
          !this.user.anagrafica &&
            this.$router.push({ name: "RegisterAnagrafica" });
          // if (this.user.role != "paziente") {
          //   this.getCategorie();
          // }
        })
        .catch(err => {
          this.msg = err;
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    },
    showModal() {
      this.$refs["pswchange"].show();
    },
    onSubmit(e) {
      this.loading = true;
      var url = process.env.VUE_APP_VERSION + "users/password/change";
      this.$axios
        .post(url, this.form)
        .then(res => {
          // this.user = res.data.data;
          console.log(res.data.data);
          this.loading = false;
          this.$bvToast.toast(`La tua password è stata aggiornata.`, {
            title: "Password aggiornata con successo!",
            autoHideDelay: 3000,
            variant: "secondary"
          });
          this.$refs["pswchange"].hide();
          this.form = {
            password: "",
            password_confirmation: "",
            old: null
          };
        })
        .catch(err => {
          this.loading = false;
          if (err.response.status === 404) {
            this.mistake = true;
            this.form.old = "";
            this.$bvToast.toast(
              `La password che hai inserito non è corretta.`,
              {
                title: "Attenzione!",
                autoHideDelay: 3000,
                variant: "danger"
              }
            );
          }
          if (err.response.status === 401) {
            this.$router.go();
          }
        });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>
